import React from 'react';
import { Skeleton } from 'antd';
import Image from 'next/image';

import { IAllUniversities } from 'modules/universities';

import ExtraUniversityList from './extra-university-list';
import UniversityStatistics from './university-statistics';

interface IProps {
  university?: IAllUniversities;
  loading?: boolean;
}

const FirstSection: React.FC<IProps> = ({ university, loading }) => (
  <div className="shadow-xs rounded-xl bg-white p-4 px-6">
    <div className="flex flex-col items-center justify-center space-y-4 text-center sm:flex-row sm:items-center sm:justify-normal sm:space-x-2 sm:space-y-0 sm:text-left">
      {!loading && university?.logo ? (
        <div className="relative max-h-17.5 min-h-17.5 min-w-17.5 max-w-17.5 overflow-hidden rounded-full">
          <Image
            fill
            className="object-cover"
            src={university?.logo}
            alt={university?.name?.slice(0, 10) || 'University Logo'}
            title="Universitet logosi"
          />
        </div>
      ) : (
        <div className="relative flex max-h-17.5 min-h-17.5 min-w-17.5 max-w-17.5 items-center justify-center overflow-hidden rounded-full bg-gray-50">
          <Image
            width={20}
            height={20}
            className="object-cover"
            src="/images/default-no-image.webp"
            alt={university?.name?.slice(0, 10) || 'University Logo'}
            title="Universitet logosi"
          />
        </div>
      )}
      {loading ? (
        <Skeleton.Button active className="!w-1/2" />
      ) : (
        <h1 className="text-sm font-bold md:text-2xl">{university?.name.toUpperCase()}</h1>
      )}
    </div>
    {loading ? (
      <>
        <Skeleton paragraph active />
        <div className="mt-3 hidden grid-cols-1 gap-5 md:grid md:grid-cols-4 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton.Button key={index} active className="!h-40 !w-full !rounded-xl" />
          ))}
        </div>
      </>
    ) : (
      <>
        <p className="my-3 text-xs text-gray-500 md:text-sm">{university?.description}</p>
        <div className="hidden md:block mt-5">
          <ExtraUniversityList
            admissionStartDate={university?.admission_start_date}
            admissionEndDate={university?.admission_end_date}
            maxContractPrice={university?.max_contract_price}
            minContractPrice={university?.min_contract_price}
            file={university?.file?.name?.trimEnd()}
          />
          <div className="mt-3">
            <UniversityStatistics
              studentsCount={university?.students_count}
              graduateStudentsCount={university?.graduate_students_count}
              experienceYearsCount={university?.experience_years_count}
              directionCount={university?.direction_count}
            />
          </div>
        </div>
      </>
    )}
  </div>
);

export default FirstSection;
